import { Component, Input, signal } from '@angular/core';
import { Parameter } from '../../entities/Parameter';

@Component({
  selector: 'app-fact-parameter',
  templateUrl: './fact-parameter.component.html',
  styleUrl: './fact-parameter.component.scss'
})
export class FactParameterComponent {
  @Input() title = "";
  @Input({ required: true }) parameter:Parameter|undefined;
  @Input() editable = signal<boolean>(false);
}
